import React, { Component } from 'react';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";

let headers = [
    {title: 'Código del proyecto'},
    {title: 'Nombre del proyecto'}
];

class ProjectsModal extends Component {
    componentDidMount(): void {
        this.closeAction();
    }


    closeProjects = async () => {
        $('#codeProjectsModal').modal('hide');  
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#codeProjectsModal').on('hidden.bs.modal', () => {
            cleanData();
        });
    };

    render() {
        const {data, selectTaxe} = this.props;
        
        if(data.length === 0){
            return <div className="modal fade bd-example-modal-lg bgtransparent" role="dialog"  id="codeProjectsModal"></div>;
        }
        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll"  role="dialog"  id="codeProjectsModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document" >
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                                <h4 className="modal-title" id="modal-basic-title ">Lista de Proyectos</h4>
                                <button type="button" className="close" onClick={this.closeImpuesto} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="w-100 table-scroll tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" >
                                                <table className="table response" style={{marginBottom: 0, height: 570, maxHeight: 570}}>
                                                    <tbody>
                                                    <DataTablesCreate data={data} headers={headers} view={"projectsModal"} action={selectTaxe}/>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeProjects}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>    
            </div>
        );
    }
}

export default ProjectsModal;